import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const BASE_URL = "https://senutour.com/api";

// ── Icônes catégories ────────────────────────────────────────
const CatIcon = ({ type, size = 22, color = "currentColor" }) => {
  const icons = {
    "Sport nautique": (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round">
        <path d="M2 20c2-2 4-3 6-3s4 1 6 3 4 3 6 3"/><path d="M2 16c2-2 4-3 6-3s4 1 6 3"/>
        <path d="M12 3v8"/><path d="M8 5l4-2 4 2"/>
      </svg>
    ),
    "Aventure": (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round">
        <path d="M3 17l4-8 4 4 3-5 4 9H3z"/><path d="M3 21h18"/>
      </svg>
    ),
    "Nature": (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round">
        <path d="M12 22V12"/><path d="M5 12c0-4 3-8 7-8s7 4 7 8"/>
        <path d="M5 17c0-2.5 3-4 7-4s7 1.5 7 4"/>
      </svg>
    ),
    "Patrimoine": (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round">
        <rect x="2" y="10" width="20" height="12" rx="1"/><path d="M12 2L2 10h20L12 2z"/>
        <rect x="9" y="14" width="6" height="8"/>
      </svg>
    ),
    "Festival": (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round">
        <path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>
      </svg>
    ),
    "Bien-être": (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
      </svg>
    ),
    "Sport": (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round">
        <circle cx="12" cy="12" r="10"/>
        <path d="M12 8l4 4-4 4-4-4 4-4z"/>
      </svg>
    ),
    "Plage": (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round">
        <path d="M17 16v5M8 16v5"/><path d="M3 16h18"/><path d="M5 16c0-5 3-9 7-9s7 4 7 9"/>
        <circle cx="12" cy="4" r="2"/>
      </svg>
    ),
    "Culture": (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round">
        <path d="M2 20h20"/><rect x="4" y="10" width="4" height="10"/><rect x="10" y="6" width="4" height="14"/>
        <rect x="16" y="13" width="4" height="7"/>
      </svg>
    ),
  };
  return icons[type] || (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round">
      <circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/>
    </svg>
  );
};

const categorieColors = {
  "Sport nautique": { bg: "rgba(26,107,139,.1)",  color: "#1A6B8B" },
  "Aventure":       { bg: "rgba(196,68,26,.1)",   color: "#C4441A" },
  "Nature":         { bg: "rgba(61,107,46,.1)",   color: "#3D6B2E" },
  "Patrimoine":     { bg: "rgba(107,61,139,.1)",  color: "#6B3D8B" },
  "Festival":       { bg: "rgba(196,68,100,.1)",  color: "#C44464" },
  "Bien-être":      { bg: "rgba(100,61,139,.1)",  color: "#643D8B" },
  "Sport":          { bg: "rgba(139,105,20,.1)",  color: "#8B6914" },
  "Plage":          { bg: "rgba(26,107,139,.1)",  color: "#1A6B8B" },
  "Culture":        { bg: "rgba(139,60,26,.1)",   color: "#8B3D1A" },
};

const categories = [
  "Sport nautique", "Aventure", "Nature", "Patrimoine",
  "Festival", "Bien-être", "Sport", "Plage", "Culture",
];

const IconArrowRight = ({ size = 15, color = "white" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round">
    <path d="M5 12h14M12 5l7 7-7 7"/>
  </svg>
);

const IconWhatsapp = ({ size = 18, color = "white" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M17.6 6.32A7.85 7.85 0 0 0 12.02 4c-4.36 0-7.9 3.53-7.9 7.9 0 1.39.36 2.75 1.06 3.95L4 20l4.27-1.12a7.9 7.9 0 0 0 3.75.96h.01c4.36 0 7.9-3.53 7.9-7.9a7.85 7.85 0 0 0-2.33-5.62zm-5.58 12.16h-.01a6.56 6.56 0 0 1-3.34-.92l-.24-.14-2.48.65.66-2.42-.16-.25a6.56 6.56 0 0 1-1.01-3.5c0-3.63 2.96-6.58 6.6-6.58a6.56 6.56 0 0 1 6.58 6.58c0 3.63-2.96 6.58-6.6 6.58zm3.6-4.93c-.2-.1-1.17-.58-1.35-.64-.18-.07-.31-.1-.44.1-.13.2-.5.64-.62.77-.11.13-.23.15-.42.05-.2-.1-.83-.31-1.58-.98-.58-.52-.98-1.16-1.09-1.36-.11-.2-.01-.3.09-.4.09-.1.2-.23.3-.35.1-.11.13-.2.2-.33.06-.13.03-.25-.02-.35-.05-.1-.44-1.06-.6-1.45-.16-.38-.32-.33-.44-.33-.11 0-.24-.01-.37-.01-.13 0-.35.05-.53.25-.18.2-.7.68-.7 1.66 0 .98.72 1.92.82 2.06.1.13 1.4 2.14 3.4 3 .48.2.85.33 1.14.42.48.15.92.13 1.26.08.38-.06 1.17-.48 1.34-.94.17-.46.17-.86.12-.94-.05-.09-.18-.14-.38-.24z"/>
  </svg>
);

const formatPrix = (p) => {
  if (!p || p === 0) return "Gratuit";
  return Number(p).toLocaleString("fr-FR") + " F";
};

// Construit un lien wa.me propre à partir d'un numéro sénégalais (ou autre)
const lienWhatsapp = (telephone, nomActivite) => {
  if (!telephone) return null;
  const numero = telephone.replace(/[^\d+]/g, "").replace(/^0/, "221"); // adapte le préfixe si besoin
  const texte = encodeURIComponent(
    `Bonjour, je suis intéressé(e) par l'activité "${nomActivite}" sur SenuTour.`
  );
  return `https://wa.me/${numero}?text=${texte}`;
};

export default function Loisirs() {
  const navigate = useNavigate();

  // ── Chargement des vraies activités publiées ──────────────────
  const [loisirs, setLoisirs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const charger = async () => {
      try {
        // ⚠️ À ajuster si ta route publique porte un autre nom côté backend
        const res = await fetch(`${BASE_URL}/loisirs`);
        const data = await res.json();
        setLoisirs(Array.isArray(data) ? data.filter(l => l.disponible) : []);
      } catch (e) {
        console.error("Erreur chargement loisirs :", e);
        setLoisirs([]);
      } finally {
        setLoading(false);
      }
    };
    charger();
  }, []);

  return (
    <div style={{ fontFamily: "'Fraunces', serif", background: "#FAF5EC", color: "#1C1008", minHeight: "100vh" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,700;0,9..144,800;1,9..144,400&family=Space+Grotesk:wght@400;500;600;700&display=swap');
        * { margin: 0; padding: 0; box-sizing: border-box; }

        @keyframes fadeUp { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:translateY(0); } }
        .fade-up { animation: fadeUp .6s ease forwards; }

        .cat-card {
          background: white; border-radius: 14px; padding: 22px 16px;
          border: 1.5px solid rgba(28,16,8,.06); text-align: center;
          position: relative; overflow: hidden;
          transition: all .25s;
        }
        .cat-card:hover { transform: translateY(-3px); box-shadow: 0 10px 30px rgba(28,16,8,.08); }

        .loisir-card {
          background: white; border-radius: 16px; overflow: hidden;
          border: 1.5px solid rgba(28,16,8,.06);
          transition: all .25s;
        }
        .loisir-card:hover { transform: translateY(-3px); box-shadow: 0 10px 30px rgba(28,16,8,.08); }

        .btn-whatsapp { background: #25D366; transition: background .2s, transform .2s; }
        .btn-whatsapp:hover { background: #1EBE57; transform: translateY(-1px); }

        @media(max-width:767px) {
          .hero-loisirs { padding: 80px 5% 48px !important; }
          .cat-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .loisirs-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>

      <Navbar transparent={false} />

      {/* ── HERO ─────────────────────────────────────────────── */}
      <section className="hero-loisirs" style={{
        background: "linear-gradient(135deg, #1C1008 0%, #2D1A08 100%)",
        padding: "100px 5% 56px", position: "relative", overflow: "hidden",
      }}>
        <div style={{ position: "absolute", inset: 0, backgroundImage: "url(https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1400&q=80)", backgroundSize: "cover", backgroundPosition: "center", opacity: .1 }} />
        <div style={{ position: "absolute", inset: 0, backgroundImage: "radial-gradient(circle, rgba(196,68,26,.08) 1px, transparent 1px)", backgroundSize: "26px 26px" }} />

        <div style={{ maxWidth: 1200, margin: "0 auto", position: "relative", zIndex: 1 }}>
          <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, fontWeight: 700, letterSpacing: 3, color: "#C4441A", textTransform: "uppercase", marginBottom: 12 }}>
            Activités & Loisirs
          </p>
          <h1 style={{ fontFamily: "'Fraunces',serif", fontSize: "clamp(28px,5vw,56px)", fontWeight: 800, color: "white", lineHeight: 1.1, letterSpacing: "-1.5px", marginBottom: 16 }}>
            Vivez le{" "}
            <span style={{ color: "#E8834A", fontStyle: "italic" }}>Sénégal</span>
            {" "}à fond
          </h1>
          <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 16, color: "rgba(255,255,255,.6)", maxWidth: 500 }}>
            Plages, culture, aventure, bien-être — des expériences uniques pour chaque voyageur.
          </p>
        </div>
      </section>

      {/* ── SECTION PRINCIPALE : activités réelles si dispo, sinon "Bientôt disponible" (inchangé) ── */}
      <section style={{ padding: "80px 5%" }}>

        {!loading && loisirs.length > 0 ? (
          // ══ ACTIVITÉS PUBLIÉES ══
          <div style={{ maxWidth: 1200, margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: 36 }}>
              <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: 3, color: "#C4441A", textTransform: "uppercase", display: "block", marginBottom: 12 }}>
                Disponible maintenant
              </span>
              <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: "clamp(22px,3.5vw,36px)", fontWeight: 800, letterSpacing: "-0.5px" }}>
                Nos activités
              </h2>
            </div>

            <div className="loisirs-grid" style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 20 }}>
              {loisirs.map((l, i) => {
                const wa = lienWhatsapp(l.telephoneContact, l.nom);
                return (
                  <div key={l.id} className="loisir-card fade-up" style={{ animationDelay: `${i * 0.05}s` }}>
                    <div style={{ height: 170, background: "linear-gradient(135deg,#1C1008,#2D1A08)", position: "relative", overflow: "hidden" }}>
                      {l.images?.[0]
                        ? <img src={l.images[0]} alt={l.nom} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                        : <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <CatIcon type={l.type} size={40} color="rgba(255,255,255,0.3)" />
                          </div>}
                      <span style={{ position: "absolute", top: 10, left: 10, display: "flex", alignItems: "center", gap: 6, fontSize: 11, fontWeight: 700, padding: "5px 10px", borderRadius: 20, background: "rgba(0,0,0,0.5)", color: "white" }}>
                        <CatIcon type={l.type} size={13} color="white" /> {l.type}
                      </span>
                    </div>
                    <div style={{ padding: 18 }}>
                      <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 17, fontWeight: 800, marginBottom: 4 }}>{l.nom}</h3>
                      <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, color: "#7A5A3A", marginBottom: 8 }}>
                        {l.ville}{l.duree ? ` · ⏱ ${l.duree}` : ""}
                      </div>
                      {l.description && (
                        <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, color: "#7A5A3A", lineHeight: 1.5, marginBottom: 14, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                          {l.description}
                        </p>
                      )}
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 12, borderTop: "1px solid #F2E4C8" }}>
                        <div style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#C4441A" }}>
                          {formatPrix(l.prix)}
                        </div>
                        {wa ? (
                          <a href={wa} target="_blank" rel="noopener noreferrer" className="btn-whatsapp"
                            style={{ display: "flex", alignItems: "center", gap: 6, color: "white", borderRadius: 8, padding: "8px 14px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, fontWeight: 700, textDecoration: "none" }}>
                            <IconWhatsapp size={15} /> Contacter
                          </a>
                        ) : (
                          <span style={{ fontSize: 11, color: "#B8A898" }}>Contact indisponible</span>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          // ══ AUCUNE ACTIVITÉ POUR LE MOMENT — invite directe à l'inscription ══
          <div style={{ maxWidth: 600, margin: "0 auto", textAlign: "center" }} className="fade-up">

            <div style={{ display: "flex", justifyContent: "center", marginBottom: 32 }}>
              <div style={{ width: 100, height: 100, borderRadius: "50%", background: "rgba(196,68,26,.07)", border: "2px solid rgba(196,68,26,.15)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <IconArrowRight size={36} color="#C4441A" />
              </div>
            </div>

            <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: "clamp(26px,4vw,42px)", fontWeight: 800, letterSpacing: "-0.5px", marginBottom: 16 }}>
              Proposez votre activité
            </h2>
            <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 16, color: "#7A5A3A", lineHeight: 1.8, marginBottom: 40 }}>
              Vous organisez des excursions, des activités sportives ou culturelles au Sénégal ? Inscrivez-vous et publiez votre activité dès maintenant.
            </p>

            <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
              <button
                onClick={() => navigate("/inscription", { state: { role: "loisir" } })}
                style={{ display: "flex", alignItems: "center", gap: 8, background: "#C4441A", color: "white", border: "none", padding: "14px 28px", borderRadius: 10, fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700, cursor: "pointer" }}
              >
                Proposer mon activité
                <IconArrowRight size={14} color="white" />
              </button>
              <button
                onClick={() => navigate("/")}
                style={{ background: "white", color: "#1C1008", border: "1.5px solid rgba(28,16,8,.15)", padding: "14px 28px", borderRadius: 10, fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 600, cursor: "pointer" }}
              >
                Retour à l'accueil
              </button>
            </div>
          </div>
        )}
      </section>

      {/* ── EXPLORER PAR CATÉGORIE (section d'origine, inchangée) ───────────────────────────── */}
      <section style={{ background: "#F0E8D4", padding: "60px 5%", borderTop: "1px solid rgba(28,16,8,.07)" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 36 }}>
            <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: 3, color: "#C4441A", textTransform: "uppercase", display: "block", marginBottom: 12 }}>
              Catégories
            </span>
            <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: "clamp(22px,3.5vw,36px)", fontWeight: 800, letterSpacing: "-0.5px" }}>
              Explorer par catégorie
            </h2>
          </div>

          <div className="cat-grid" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", gap: 14 }}>
            {categories.map((c, i) => {
              const cc = categorieColors[c] || categorieColors["Culture"];
              const nb = loisirs.filter(l => l.type === c).length;
              return (
                <div key={c} className="cat-card" style={{ animationDelay: `${i * 0.05}s` }}>
                  <div style={{ width: 52, height: 52, borderRadius: 14, background: cc.bg, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 12px" }}>
                    <CatIcon type={c} size={24} color={cc.color} />
                  </div>
                  <div style={{ fontFamily: "'Fraunces',serif", fontSize: 15, fontWeight: 700, marginBottom: 4, color: "#1C1008" }}>{c}</div>
                  <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, color: "#B8A898" }}>
                    {nb > 0 ? `${nb} activité${nb > 1 ? "s" : ""}` : "Aucune pour le moment"}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}